export const ADD_USER_ROW_SUCCESS = "ADD_USER_ROW_SUCCESS";
export const REMOVE_USER_ROW_SUCCESS = "REMOVE_USER_ROW_SUCCESS";
export const UPDATE_USER_ROW_SUCCESS = "UPDATE_USER_ROW_SUCCESS";
export const CLEAR_USER_ROW_SUCCESS = "CLEAR_USER_ROW_SUCCESS";
export const ADD_ATTRIBUT_ROW_SUCCESS = "ADD_ATTRIBUT_ROW_SUCCESS";
export const REMOVE_ATTRIBUT_ROW_SUCCESS = "REMOVE_ATTRIBUT_ROW_SUCCESS";
export const UPDATE_ATTRIBUT_ROW_SUCCESS = "UPDATE_ATTRIBUT_ROW_SUCCESS";
export const CLEAR_ATTRIBUT_ROW_SUCCESS = "CLEAR_ATTRIBUT_ROW_SUCCESS";
